import { render, staticRenderFns } from "./Physiology-Edit.vue?vue&type=template&id=644601d6&"
import script from "./Physiology-Edit.js?vue&type=script&lang=js&"
export * from "./Physiology-Edit.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports